<template lang="pug">
div
  .row
    .col-2
      h3 Game Settings
      form.p-2
        .mb-2
          label.form-label Zoom Level
          input.form-control-range(type="range", list="tickmarks", v-model.number="scale", step=".25", min=".5", max="3")
          small.help-text zoom level: {{ scale }}

          datalist#tickmarks
            option(value="0.50")
            option(value="0.75")
            option(value="1.00")
            option(value="1.25")
            option(value="1.50")
            option(value="1.75")
            option(value="2.00")
            option(value="2.25")
            option(value="2.50")
            option(value="2.75")
            option(value="3.00")

        div
          label.form-label Board Size ( {{ width }}w x {{ height }}h )
          .d-flex.justify-content-between
            .flex-fill: input.form-control(type="number", list="tickmarks", v-model.number.lazy="width", step="1", min="6", max="24", size="3")
            .text-center.pt-2: span(style="margin: 0 10px") x
            .flex-fill: input.form-control(type="number", list="tickmarks", v-model.number.lazy="height", step="1", min="6", max="14", size="3")

        div
          label.form-label Starting Level {{ level }}
          input.form-control(type="number", v-model.number="level", step="1", min="1", max="9")

        div
          label.form-label Colors
          .d-flex.justify-content-between
            .flex-fill
              label.mr-2 Pipe
              input.form-control(type="color", v-model="forecolor" )
            .px-2
            .flex-fill
              label Board
              input.form-control(type="color", v-model="backcolor" )
            .px-2
            .flex-fill
              label Bricks
              input.form-control(type="color", v-model="altcolor" )

        div
          label.form-label Allow replacing jagged tiles
          label.mr-2
            input(type="radio", v-model="canReplaceJaggedTiles", :value="true")
            | Yes
          label
            input(type="radio", v-model="canReplaceJaggedTiles", :value="false")
            | No

      button.btn.btn-green(@click="goBack", type="button") Update
    .col
      canvas(ref="canvas", :style="canvasStyle")
</template>

<script>
import PipesCanvas from "@/components/PipesCanvas"
import { unpivot } from "@/utils"
import CanvasGen from "@/canvas"
let sample = [
  ["tl", "tr", "tl", "tr", "bb", "bb", "tl", "tr", "tl", "lh", "tr", "tl", "tr", null, null, null, null, null, null, null, null, "tl", "tr", "bb"],
  ["lv", "bl", "br", "bl", "ul", "ur", "ar", "al", "br", "tl", "cr", "cr", "cr", null, null, null, null, null, null, null, null, "ar", "al", "tr"],
  ["jv", "bb", "tl", "tr", "tl", "lh", "qr", "ql", "jh", "cr", "cr", "cr", "br", null, null, null, null, null, null, null, null, "qr", "ql", "br"],
  ["lv", "tl", "cr", "cr", "br", "tl", "cr", "cr", "sl", "jv", "jv", "jv", null, null, null, null, null, null, null, null, null, "ar", "al", "tr"],
  ["bl", "cr", "br", "bl", "jh", "br", "jv", "jv", "tl", "ar", "al", "br", null, null, null, null, null, null, null, null, null, "qr", "ql", "br"],
  ["tl", "cr", "tr", "tl", "tr", "tl", "cr", "cr", "cr", "qr", "ql", "lh", "cr", "br", null, null, null, null, null, null, null, "ar", "al", "tr"],
  ["bl", "br", "bl", "cr", "cr", "br", "bl", "br", "bl", "ar", "al", "lh", "cr", "tr", null, null, null, null, null, "ar", "al", "qr", "ql", "br"],
  ["tl", "lh", "lh", "br", "bl", "ul", "ur", "ul", "ur", "qr", "ql", "tr", null, null, null, null, null, null, null, "qr", "ql", "ar", "al", "tr"],
  ["jv", "tl", "ul", "ur", "ul", "ur", "tr", "tl", "jh", "cr", "br", "lv", null, null, null, null, null, null, null, "ar", "al", "qr", "ql", "br"],
  ["jv", "lv", "tl", "tr", "tl", "tr", "lv", "lv", "tl", "cr", "jh", "cr", "cr", "tr", null, null, null, null, null, "qr", "ql", "ar", "al", "tr"],
  ["bl", "cr", "cr", "cr", "cr", "ar", "al", "cr", "cr", "cr", "jh", "cr", "cr", "br", "tl", "tr", "tl", "tr", "tl", "ar", "al", "qr", "ql", "br"],
  ["tl", "cr", "cr", "cr", "cr", "qr", "ql", "cr", "cr", "cr", "tr", "bl", "cr", "jh", "cr", "cr", "cr", "cr", "cr", "qr", "ql", "ar", "al", "tr"],
  ["jv", "bl", "br", "bl", "br", "lv", "jv", "bl", "br", "bl", "br", "tl", "cr", "jh", "cr", "cr", "br", "bl", "br", "bl", "cr", "qr", "ql", "br"],
  ["bl", "ul", "ur", "ul", "ur", "br", "bl", "lh", "lh", "lh", "lh", "br", "bl", "jh", "br", "bl", "jh", "jh", "jh", "jh", "br", "bl", "br", "bb"]
]
const debounce = (func, delay) => {
  let inDebounce
  return function() {
    const context = this
    const args = arguments
    clearTimeout(inDebounce)
    inDebounce = setTimeout(() => func.apply(context, args), delay)
  }
}

export default {
  name: "SettingsPage",
  components: { PipesCanvas },
  data() {
    return {
      board: null,
      sample: null,
      loadText: JSON.stringify(sample)
    }
  },
  watch: {
    scale() {
      debounce(this.draw, 500)
    },
    width() {
      this.draw()
    },
    height() {
      this.draw()
    },
    altcolor() {
      this.draw()
    },
    foreolor() {
      this.draw()
    },
    backcolor() {
      this.draw()
    }
  },
  mounted() {
    this.ctx = this.$refs.canvas.getContext("2d")
    this.sample = unpivot(sample)
    this.draw()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    draw() {
      console.log("Draw")
      let ctx = this.$refs.canvas.getContext("2d")
      let w = this.width
      let h = this.height
      ctx.fillRect(0, 0, w * this.scaledTile, h * this.scaledTile)
      ctx.canvas.width = w * this.scaledTile
      ctx.canvas.height = h * this.scaledTile
      let cg = new CanvasGen(this.scale, this.scaledTile, this.scaledDrop, this.forecolor, this.backcolor, this.altcolor)

      let arr = new Array(this.width)
      for (let x = 0; x < w; x++) {
        arr[x] = new Array(this.height)
        for (let y = 0; y < h; y++) {
          let p = this.sample[x][y]
          if (["itl", "itr", "ibl", "tur"].includes(p.c)) continue
          if (p.c === null) continue

          this.ctx.drawImage(cg[p.c], p.y * this.scaledTile, p.x * this.scaledTile)
        }
      }
    }
  },
  computed: {
    scaledTile() {
      return this.scale * this.$tileSize
    },
    scaledDrop() {
      return this.scale * this.$dropSize
    },
    level: {
      get() {
        return this.$state.level
      },
      set(value) {
        this.$state.level = value
      }
    },
    scale: {
      get() {
        return this.$state.scale
      },
      set(value) {
        this.$state.scale = value
      }
    },
    forecolor: {
      get() {
        return this.$state.forecolor || "silver"
      },
      set(value) {
        this.$state.forecolor = value
      }
    },
    backcolor: {
      get() {
        return this.$state.backcolor || "#f6f6f6"
      },
      set(value) {
        this.$state.backcolor = value
      }
    },

    altcolor: {
      get() {
        return this.$state.altcolor || "gray"
      },
      set(value) {
        this.$state.altcolor = value
      }
    },

    width: {
      get() {
        return this.$state.tiles.w
      },
      set(value) {
        this.$state.tiles.w = value
      }
    },
    height: {
      get() {
        return this.$state.tiles.h
      },
      set(value) {
        this.$state.tiles.h = value
      }
    },
    canReplaceJaggedTiles: {
      get() {
        return this.$state.canReplaceJaggedTiles
      },
      set(value) {
        this.$state.canReplaceJaggedTiles = value
      }
    },
    canChangeColor: {
      get() {
        return this.$state.canChangeColor
      },
      set(value) {
        this.$state.canChangeColor = value
      }
    },
    canvasStyle() {
      return {
        height: this.height * this.scaledTile + "px",
        width: this.width * this.scaledTile + "px"
      }
    }
  }
}
</script>

<style lang="scss" scoped>
canvas {
  background-color: bisque;
  border: 1px solid rgb(247, 142, 15);
}
form {
  .form-label {
    font-weight: bold;
    break-after: always;
    display: block;
  }
  & > div {
    margin-bottom: 20px;
  }
}
</style>
